'use client';

import { useEffect } from 'react';
export default function Pwa() {
  useEffect(() => {
    if (!('serviceWorker' in navigator)) return;
    navigator.serviceWorker.getRegistrations().then(registrations => {
      registrations.forEach(registration => {
        if (registration.active && registration.active.scriptURL.includes('najva')) {
          registration.unregister();
        }
      });
    });
  }, []);
  useEffect(() => {
    if (!('serviceWorker' in navigator)) return;
    navigator.serviceWorker.register('/sw.js', {
      scope: '/'
    }).then(registration => {
      // eslint-disable-next-line no-console
      console.log('Service Worker registration successful with scope: ', registration.scope);
    }).catch(err => {
      // eslint-disable-next-line no-console
      console.log('Service Worker registration failed: ', err);
    });
  }, []);
  return null;
}